<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead :title="'Queues'"></cardHead>
      <load-area v-if="data == null"></load-area>
      <ul v-if="data != null" class="row border-bottom">
        <li v-for="item in data" :key="item.Name" class="col">
          <div class="card m-0">
            <div class="card-body tcenter p-10">
              <h5 :title="item.Name">{{ item.Name }}</h5>
              <h6 class="text-muted m-b-0 p-t-10">
                  Consumer/Message
                  <span class="block p-t-5 text-primary">
                    {{ item.ConsumerCount }}/
                    {{ item.MessageCount }}
                  </span>
              </h6>
              <button class="btn btn-xs waves-effect waves-light btn-danger" @click="purge(item.Name)"><i class="fas fa-trash-alt"></i></button>
            </div>
          </div>
        </li>
      </ul>
          <apexChart
            :data='[
                {
                  name: "Queues",
                  data: chartData,
                }
              ]'
            :height="200"
            :chartOptions="chartOptions"
            :type="'area'"
          ></apexChart>
    </div>
  </div>
</template>

<script>
import apexChart from "./../../components/apexChart.vue";
export default {
  name: "queues",
  // props:["data","get"],
  components:{
    apexChart
  },
  data() {
    return {
      tab: "Customers",
      data: null,
      chartOptions: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            borderRadiusApplication: "last",
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip:{
          y:{
            formatter: function(val){
              if(val==0){
                return "";
              }
              return val
            },
          }
        },
        dataLabels: {
          formatter: function(val) {
            // const goals =
            //   opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
            //     .goals;

            // if (goals && goals.length) {
            //   return "%" + goals[1].value;
            // }
            return val;
          },
        },
      },
      chartDataTrace:{
        index:0,
        value:0
      },
      chartData:[],
      isSendRequest: false,
    };
  },
  created() {
    for (let index = 0; index < 60; index++) {
      this.chartData.push( 0)
    }
    this.get();
    setInterval(() => {
      this.get();
    }, 10000);
  },
  methods: {
    get() {
      if(this.isSendRequest){
        return false;
      }
      this.isSendRequest=true;
      this.$appAxiosAdmin.get(`Queues`).then((response) => {
      this.isSendRequest=false;
        this.data = response.data.sort((x,y)=>{return y.MessageCount-x.MessageCount});
        if(this.chartDataTrace.value<this.data[0].MessageCount){
          this.chartDataTrace.value=this.data[0].MessageCount;
        }
        this.chartDataTrace.index++;
        if(this.chartDataTrace.index==12){
          this.chartData.push(this.chartDataTrace.value);
          this.chartData.splice(0,1)
          this.chartDataTrace.index=0;
          this.chartDataTrace.value=0;
        }

      });
    },
    purge(name){
      this.$appAxiosAdmin.get(`Queues/Purge/`+name).then(() => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully purged the queue.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        this.get();
      });
    },
    setChartData100(){
      let data=[...this.chartData];
      if(data.length<100){
        for (let index = 0; index < 100-data.length; index++) {
          data.unshift(0);
        }
      }
      return data;
    }
  },
};
</script>
<style scoped>
  ul{
    margin:0px;
    padding: 5px;
    height:107px;
    overflow: hidden;
  }
  ul li{
    padding: 5px;
    position: relative;
    width: 16%;
  }
  ul li h5{
    white-space: nowrap;
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  ul li button{
    position: absolute;
    right:0;
    bottom:0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  
@media (max-width:991px) {
  ul{
    height:204px;
  }
}
@media (max-width:767px) {
  ul{
    height:301px;
  }
}
@media (max-width:567px) {
  ul{
    height: 495px;
  }
}
</style>
